






import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "DocumentInstructions",
    components: {},
    props: {
        reviewInstructions: String,
        suppressInstructions: Boolean
    },
    data: function () {
        return {};
    },
    computed: {},
    methods: {},
    watch: {
        suppressInstructions(newValue) {
            this.$emit("suppress-changed", newValue);
        }
    }
});
